module.exports = __webpack_public_path__ + "static/media/NP-steak.4075b3e2.jpeg";